import { observer } from 'mobx-react-lite';
import React, { useEffect } from 'react';
import { TileAssetConfigurator } from './TileAssetConfigurator';
import { EditorTileAssetViewerContainer } from './EditorTileAssetViewerContainer';
import styled from "styled-components";
import { UndoRedoSlideMenu } from '../editor/UndoRedoSlideMenu';
import { TileAssetEditorTileSelector } from './TileAssetEditorTileSelector';
const Container = styled.div.withConfig({
  displayName: "TileAssetEditor__Container",
  componentId: "sc-17y6z46-0"
})(["padding-top:40px;display:flex;flex-direction:column;position:fixed;left:0.3em;right:0.3em;bottom:0.3em;top:0.3em;overflow:hidden;"]);
const Row = styled.div.withConfig({
  displayName: "TileAssetEditor__Row",
  componentId: "sc-17y6z46-1"
})(["display:flex;flex-direction:row;"]);
export const TileAssetEditor = observer(() => {
  useEffect(() => {
    document.oncontextmenu = function (event) {
      event.preventDefault();
    };

    return () => {
      document.oncontextmenu = null;
    };
  }, []);
  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(UndoRedoSlideMenu, null), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(EditorTileAssetViewerContainer, null), /*#__PURE__*/React.createElement(TileAssetConfigurator, null)), /*#__PURE__*/React.createElement(TileAssetEditorTileSelector, null));
});